import * as React from "react";
import { CustomCheckbox } from "../../customFormComponents/CheckBoxGroup/Checkbox";
import { IGenericsLang, ILabelSelect } from "../../../services/Language/Types";

export interface IMultiClinicSiteTabProps {
    siteOptions: ILabelSelect[];
    textString: IGenericsLang;
    onSiteSelectionChange(checked: boolean, value: string | number): void;
}


export const MultiClinicSiteTab = (props: IMultiClinicSiteTabProps) => {
    const { siteOptions, textString, onSiteSelectionChange } = props;

    // Memoize grouped and sorted site structure
    const { groupedParents, sortedLabels, childrenByParent } = React.useMemo(() => {

        const parentSites = siteOptions.filter(s => !s.parentSiteId);

        const groupedParents = parentSites.reduce((acc, parent) => {
            if (!acc[parent.label]) acc[parent.label] = [];
            acc[parent.label].push(parent);
            return acc;
        }, {} as Record<string, ILabelSelect[]>);

        // Build map of parent value -> sorted children
        const children = new Map<string | number, ILabelSelect[]>();
        siteOptions.forEach(site => {
            if (site.parentSiteId) {
                if (!children.has(site.parentSiteId)) {
                    children.set(site.parentSiteId, []);
                }
                children.get(site.parentSiteId)!.push(site);
            }
        });

        // Sort each group of children alphabetically
        children.forEach(childArray => {
            childArray.sort((a, b) => (a.label || "").localeCompare(b.label || ""));
        });

        // Sort parent labels alphabetically
        const sorted = Object.keys(groupedParents).sort((a, b) => a.localeCompare(b));

        return {
            groupedParents: groupedParents,
            sortedLabels: sorted,
            childrenByParent: children
        };
    }, [siteOptions]);

    return (
        <div className="text-left">
            <h2>{textString.titles.SelectMultiSiteTitle}</h2> 

            <div className = "border-box">       
                    {sortedLabels.map(label => (
                        <div key={`group-label-${label}`}>
                            <div className="multiSites-header">
                                <div className="multiSites-title">{label}</div>
                            </div>
                            <div>
                                {groupedParents[label].map(parent => {
                                    const children = childrenByParent.get(parent.value) || [];
                                    if (children.length === 0) return null;

                                    return (
                                        <div key={`parent-${parent.value}`} className="multiSites-body">
                                            {children.map(child => (
                                                <div key={`checkbox-${child.value}`} className="mb-1">
                                                    <CustomCheckbox
                                                        label={child.label}
                                                        checked={child.checked}
                                                        onClick={() => onSiteSelectionChange(!child.checked, child.value)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Tabs/MultiClinicSiteTab.tsx